import { getCompanyBaseProjectCostCategories, getCostBaseProjects, getCostSpecialtiesCompany, getCompanyCostTemplates, getCompanyCostItems } from "@/helpers/api/costs"
import {getSpecialties} from '@/helpers/api/company'

const costTableColorMap = localStorage.getItem('cost_table_colors')

const DashboardStore = {
  namespaced: true,
  state: {
		costTableBlocked: false,
		loadingCompaniesSpecialties: false,
		companiesSpecialties: [],
		loadingCompaniesBaseProjects: false,
		companiesBaseProjects: [],
		loadingCompaniesCostSpecialties: false,
		companiesCostSpecialties: [],
		companiesCostGeneralSubCategories: [],
		loadingCompaniesCostTemplates: false,
		companiesCostTemplates: [],
		newCostBreakdownBaseProjectModal: false,
		newCostBreakdownBaseProjectModalEditing: null,
		newCostBreakdownCategoryModal: false,
		newCostBreakdownCategoryModalEditing: null,
		newCostBreakdownSubCategoryModal: false,
		newCostBreakdownSubCategoryModalEditing: null,
		newCostBreakdownItemModal: false,
		newCostBreakdownItemModalEditing: null,
		costBreakdownMainTableModal: false,
		costBreakdownSummaryTablesModal: false,
		costBreakdownSubcontractTablesModal: false,
		costBreakdownSubcontractTablesModalInfo: null,
		subPaymentCostBreakdownConfiguration: null,
		loadingCompaniesCostItems: false,
		companiesCostItems: [],
		loadingCompanyCostConfig: false,
		companyCostConfig: null,
		costTableColorMap: {
			costTablePrimaryColor: '#263238',
			costTableSecondaryColor: '#546e7a',
			costTableThirdColor: '#37474f',
			costTableFourthColor: '#90a4ae',
			costTableSectionsMain: '#37474f',
			costTableSectionsProjects: '#37474f',
			costTableSectionsReception: '#37474f',
			costTableSectionsStages: '#37474f',
			costTableSectionsSpecialties: '#37474f',
			summaryTableColor: 'green',
			paymentStatusTableColor: '#2196F3',
			footerPaymentStatusColor: '#2196F3',
			secondFooterPaymentStatusColor: '#2196F3',
			paymentsTableColor: '#009688',
			paymentConfigTableColor: '#03A9F4',
			subcontractConfigTableColor: '#8e24aa',
			subcontractConfigTableColorSubheader: '#1544bb',
			supervisionTableColor: '#3f51b5',
			footerSummaryTables: '#37474f',
			footerPaymentConfigTableColor: '#37474f',
			footerSupervisionTables: '#37474f',
			...(
				costTableColorMap
					? JSON.parse(costTableColorMap)
					: {}
			)
		},
		modalProjectTables: null,
		showModalProjectTables: false,
		costPdfModal: null,
  },
  mutations: {
		setCostTableBlocked(state, status){
			state.costTableBlocked = status
		},
    setLoadingCompaniesBaseProjects(state, status) {
      state.loadingCompaniesBaseProjects = status
    },
    setCompaniesBaseProjects(state, projects) {
      state.companiesBaseProjects = projects
    },
    setLoadingCompaniesSpecialties(state, status) {
      state.loadingCompaniesSpecialties = status
    },
    setCompaniesSpecialties(state, specialties) {
      state.companiesSpecialties = specialties
    },
    setLoadingCompaniesCostSpecialties(state, status) {
      state.loadingCompaniesCostSpecialties = status
    },
    setCompaniesCostSpecialties(state, categories) {
      state.companiesCostSpecialties = categories
    },
		setLoadingCompaniesCostItems(state, status) {
      state.loadingCompaniesCostItems = status
    },
		setCompaniesCostItems(state, status) {
      state.companiesCostItems = status
    },
    setCompaniesCostGeneralSubCategories(state, subcategories) {
      state.companiesCostGeneralSubCategories = subcategories
    },
    setLoadingCompaniesCostTemplates(state, status) {
      state.loadingCompaniesCostTemplates = status
    },
    setCompaniesCostTemplates(state, templates) {
      state.companiesCostTemplates = templates
    },
    setNewCostBreakdownBaseProjectModal(state, modal) {
      state.newCostBreakdownBaseProjectModal = modal
    },
    setNewCostBreakdownBaseProjectModalEditing(state, info) {
      state.newCostBreakdownBaseProjectModalEditing = info
    },
    setNewCostBreakdownCategoryModal(state, modal) {
      state.newCostBreakdownCategoryModal = modal
    },
    setNewCostBreakdownCategoryModalEditing(state, info) {
      state.newCostBreakdownCategoryModalEditing = info
    },
    setNewCostBreakdownSubCategoryModal(state, modal) {
      state.newCostBreakdownSubCategoryModal = modal
    },
    setNewCostBreakdownSubCategoryModalEditing(state, info) {
      state.newCostBreakdownSubCategoryModalEditing = info
    },
    setNewCostBreakdownItemModal(state, modal) {
      state.newCostBreakdownItemModal = modal
    },
    setNewCostBreakdownItemModalEditing(state, info) {
      state.newCostBreakdownItemModalEditing = info
    },
    setLoadingCompanyCostConfig(state, value) {
      state.loadingCompanyCostConfig = value
    },
    setCompanyCostConfig(state, value) {
      state.companyCostConfig = value
    },
		setCostBreakdownMainTableModal(state, status) {
      state.costBreakdownMainTableModal = status
    },
		setCostBreakdownSummaryTablesModal(state, status) {
      state.costBreakdownSummaryTablesModal = status
    },
		setCostBreakdownSummaryTablesModalInfo(state, info) {
      state.costBreakdownSummaryTablesModalInfo = info
    },
		setCostTableColorMap(state, payload) {
			Object.assign(state.costTableColorMap, payload)
			localStorage.setItem('cost_table_colors', JSON.stringify(state.costTableColorMap))
    },
		setModalProjectTables(state, modal) {
      state.modalProjectTables = modal
    },
		setShowModalProjectTables(state, status) {
      state.showModalProjectTables = status
    },
		setSubPaymentCostBreakdownConfiguration(state, data) {
      state.subPaymentCostBreakdownConfiguration = data
    },
		setCostBreakdownSubcontractTablesModal(state, status) {
			state.costBreakdownSubcontractTablesModal = status
		},
		setCostPdfModal(state, modal) {
			state.costPdfModal = modal
		}
  },
  actions: {
    async getCompanyCostConfig({ commit }, {company_base_project_id = null} = {}) {
      commit('setLoadingCompanyCostConfig', true)
      const cost_categories = await getCompanyBaseProjectCostCategories({company_base_project_id})
      if (cost_categories.code === 200) {
        commit('setCompanyCostConfig', cost_categories.cost_categories)
      }
      commit('setLoadingCompanyCostConfig', false)
    },
    async getCompanyBaseProjects({ commit }) {
      commit('setLoadingCompaniesBaseProjects', true)
      const base_projects = await getCostBaseProjects()
      if (base_projects.code === 200) {
        commit('setCompaniesBaseProjects', base_projects.base_projects)
      }
      commit('setLoadingCompaniesBaseProjects', false)
    },
    async getCompanySpecialties({ commit }) {
      commit('setLoadingCompaniesSpecialties', true)
      const specialties = await getSpecialties()
      if (specialties.code === 200) {
        commit('setCompaniesSpecialties', specialties.specialties)
      }
      commit('setLoadingCompaniesSpecialties', false)
    },
    async getCompanyCostItems({ commit }) {
      commit('setLoadingCompaniesCostItems', true)
      const categories = await getCompanyCostItems()
      if (categories.code === 200) {
        commit('setCompaniesCostItems', categories.cost_items)
      }
      commit('setLoadingCompaniesCostItems', false)
    },
    async getCompanyCostSpecialties({ commit }) {
      commit('setLoadingCompaniesCostSpecialties', true)
      const categories = await getCostSpecialtiesCompany()
      if (categories.code === 200) {
        commit('setCompaniesCostSpecialties', categories.cost_categories)
      }
      commit('setLoadingCompaniesCostSpecialties', false)
    },
    async getCompanyCostTemplates({ commit }) {
      commit('setLoadingCompaniesCostTemplates', true)
      const categories = await getCompanyCostTemplates()
      if (categories.code === 200) {
        commit('setCompaniesCostTemplates', categories.cost_template)
      }
      commit('setLoadingCompaniesCostTemplates', false)
    },
  }
}

export default DashboardStore
